import { formTypes } from "./../../Forms/Containers/FormCreator";

import { getMasterRef } from "../../Services/service";

export const victimObject = async (variable) => {
  return new Promise((res) => {
    let datas = {}
    // let deptos = await sendService("/api/v1/geo/getDeptos", "GET")
    // deptos = deptos.status === 200 ? deptos.response : []
    let cont = 0
    const cant = 5
    getMasterRef('genero').then(value => {
      datas = {
        ...datas,
        genero: value
      }
      cont++
      if (cont === cant) {
        res(setObject(datas, variable))
      }
    })
    getMasterRef('arma').then(value => {
      datas = {
        ...datas,
        arma: value
      }
      cont++
      if (cont === cant) {
        res(setObject(datas, variable))
      }
    })
    getMasterRef('descConducta').then(value => {
      datas = {
        ...datas,
        conducta: value
      }
      cont++
      if (cont === cant) {
        res(setObject(datas, variable))
      }
    })
    getMasterRef('modalidad').then(value => {
      datas = {
        ...datas,
        modalidad: value
      }
      cont++
      if (cont === cant) {
        res(setObject(datas, variable))
      }
    })
    getMasterRef('causamuerte').then(value => {
      datas = {
        ...datas,
        causa: value
      }
      cont++
      if (cont === cant) {
        res(setObject(datas, variable))
      }
    })
  })
};



const setObject = async (data, props) => {
  console.log(props)
  console.log(data)
  return [
    {
      type: formTypes.title,
      classContainer: "line line-100 align-center",
      classLabel: "input-text",
      label: "Información de la víctima",
      // required: true,
      variable: "title",
      value: ""
    },
    {
      type: formTypes.text,
      classContainer: "line line-100",
      // classInput: "form-control",
      classLabel: "input-text",
      label: "Nombre de la víctima",
      placeholder: "Ingrese por favor el nombre completo",
      required: false,
      variable: "victima",
      value: ""
    },
    {
      type: formTypes.number,
      classContainer: "line line-50",
      // classInput: "form-control",
      classLabel: "input-text",
      label: "Edad de la víctima",
      placeholder: "Edad en años",
      required: false,
      variable: "edad",
      value: ""
    },
    {
      type: formTypes.select,
      label: "Género",
      placeholder: "Seleccione género",
      required: false,
      classContainer: "line line-50",
      classLabel: "input-text",
      // classInput: "form-control",
      variable: "refGeneroId",
      keyValue: "id",
      keyText: "name",
      // data: [],
      data: data.genero,
      value: []
    },
    {
      type: formTypes.select,
      label: "Arma empleada",
      placeholder: "Seleccione el tipo de arma",
      required: false,
      classContainer: "line line-50",
      classLabel: "input-text",
      // classInput: "form-control",
      variable: "refMedioId",
      keyValue: "id",
      keyText: "name",
      // data: [],
      data: data.arma,
      value: []
    },
    {
      type: formTypes.select,
      label: "Modalidad",
      placeholder: "Seleccione modalidad",
      required: false,
      classContainer: "line line-50",
      classLabel: "input-text",
      // classInput: "form-control",
      variable: "refModalidadId",
      keyValue: "id",
      keyText: "name",
      data: data.modalidad,
      // data: await getMasterRef('modalidad'),
      value: []
    },
    {
      type: formTypes.select,
      label: "Conducta",
      placeholder: "Seleccione la descripción de la conducta",
      required: false,
      classContainer: "line line-50",
      classLabel: "input-text",
      // classInput: "form-control",
      variable: "refDescripcionConductumId",
      keyValue: "id",
      keyText: "name",
      data: data.conducta,
      // data: await getMasterRef('modalidad'),
      value: []
    },
    {
      type: formTypes.select,
      label: "Causa muerte",
      placeholder: "Seleccione la causa de lesión o muerte",
      required: false,
      classContainer: "line line-50",
      classLabel: "input-text",
      // classInput: "form-control",
      variable: "refCausadId",
      keyValue: "id",
      keyText: "name",
      // data: [],
      data: data.causa,
      value: []
    },
    {
      type: formTypes.div,
      classContainer: "line line-100"
    },
    {
      type: formTypes.div,
      classContainer: "line line-25"
    },
    {
      type: formTypes.buttonclick,
      classContainer: "button-primary line line-25 text-center",
      label: "Cancelar",
      placeholder: "-",
      onClick: props.closeModal
    },
    {
      type: formTypes.submit,
      classContainer: "button-primary line line-25 text-center",
      label: "Agregar",
      placeholder: "-"
    },
    {
      type: formTypes.div,
      classContainer: "line line-100"
    }
  ]
}
